import { render, staticRenderFns } from "./MultipleChoiceInputGrid.vue?vue&type=template&id=4b4683f3&scoped=true&"
import script from "./MultipleChoiceInputGrid.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceInputGrid.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceInputGrid.vue?vue&type=style&index=0&id=4b4683f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4683f3",
  null
  
)

export default component.exports